const validColors = ['primary', 'error', 'warning', 'success', ''] as const
type ButtonColorType = (typeof validColors)[number]
type ValidType = 'primary' | 'ghost' | 'dashed' | 'link' | 'text' | 'default'
type SizeType = 'small' | 'middle' | 'large'

export const buttonProps = {
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  hidden: {
    type: Boolean,
    default: false,
  },
  auth: {
    type: String,
  },
  color: {
    type: String as PropType<ButtonColorType>,
    validator: v => validColors.includes(v),
    default: '',
  },
  type: {
    type: String as PropType<ValidType>,
    default: 'default',
  },
  size: {
    type: String as PropType<SizeType>,
    default: 'middle',
  },
  block: { type: Boolean },
  ghost: { type: Boolean },
  loading: { type: Boolean },
  disabled: { type: Boolean },
  /**
   * Text before icon.
   */
  preIcon: { type: String },
  /**
   * Text after icon.
   */
  postIcon: { type: String },
  /**
   * preIcon and postIcon icon size.
   * @default: 14
   */
  iconSize: { type: Number, default: 14 },
  onClick: { type: [Function, Array] as PropType<((...args: any[]) => any)>, default: null },
}
